// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import Multiselect from 'react-widgets/lib/Multiselect'
import DropDownList from 'react-widgets/lib/DropdownList'
import DateTimePicker from 'react-widgets/lib/DateTimePicker'
import momentLocalizer from 'react-widgets-moment'
import moment from 'moment'
import Toggle from 'react-toggle'
import classnames from 'classnames'

import {Editor} from 'react-draft-wysiwyg'
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import {convertToRaw, convertFromRaw, EditorState} from 'draft-js'
import {mdToDraftjs, draftjsToMd} from 'draftjs-md-converter'

import ErrorIcon from '@material-ui/icons/Error'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import 'react-widgets/dist/css/react-widgets.css'
import 'react-toggle/style.css'
import './form.css'
import './index.css'

moment.locale('en')
momentLocalizer()

export class FormGroup extends Component {
  render () {
    const {labelText, helpText, displayInline, className} = this.props
    const label = labelText && (
      <label htmlFor={this.props.children.props.name}>
        {labelText}
      </label>
    )
    const help = helpText && <small>{helpText}</small>
    return (
      <div className={classnames('form-group', {'form-group-inline': displayInline}, className)}>
        {label}
        {this.props.children}
        {help}
      </div>
    )
  }
}

export class FormFieldError extends Component {
  render () {
    const {meta} = this.props
    const hasError = meta.touched && meta.error
    const hasWarning = meta.warning
    return (
      <div className={classnames('input-group', {'input-group-error': hasError})}>
        {this.props.children}
        {hasError && (
          <div className='error'>
            <ErrorIcon/>{meta.error}
          </div>
        )}
        {hasWarning && (
          <div className='warning'>
            <i className='fal fa-exclamation-circle'/> {meta.warning}
          </div>
        )}
      </div>
    )
  }
}

export class InputField extends Component {
  render () {
    return (
      <FormFieldError {...this.props}>
        <input {...this.props.input}
          type={this.props.type || 'text'}
          id={this.props.input.name}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          {...this.props}
        />
        {this.props.icon &&
          <div className='icon'>
            {this.props.icon}
          </div>
        }
      </FormFieldError>
    )
  }
}

export class CheckboxField extends Component {
  render () {
    return (
      <FormFieldError {...this.props}>
        <Toggle name={this.props.input.name}
          checked={!!this.props.input.value}
          onChange={this.props.input.onChange}
          {...this.props}
        />
      </FormFieldError>
    )
  }
}

export class SelectField extends Component {
  render () {
    return (
      <FormFieldError {...this.props}>
        <select {...this.props.input}
          id={this.props.input.name}>
          {this.props.children}
        </select>
      </FormFieldError>
    )
  }
}

export class MultiselectField extends Component {
  render () {
    const {
      input, data, disabled, filter, valueField, textField, onSearch,
      allowCreate, onCreate
    } = this.props
    return (
      <FormFieldError {...this.props}>
        <Multiselect {...input}
          onBlur={() => input.onBlur()}
          value={input.value || []} // requires value to be an array
          data={data}
          disabled={disabled}
          filter={filter}
          valueField={valueField}
          textField={textField}
          onSearch={onSearch}
          allowCreate={allowCreate}
          onCreate={onCreate} />
      </FormFieldError>
    )
  }
}

export class DropDownListField extends Component {
  render () {
    const {
      input, data, disabled, filter, allowCreate, onCreate, valueField,
      textField, onSearch
    } = this.props
    return (
      <FormFieldError {...this.props}>
        <DropDownList {...input}
          onBlur={() => input.onBlur()}
          data={data}
          disabled={disabled}
          filter={filter}
          allowCreate={allowCreate}
          onCreate={onCreate}
          valueField={valueField}
          textField={textField}
          selectIcon={<ExpandMoreIcon/>}
          onSearch={onSearch}
          {...this.props}/>
      </FormFieldError>
    )
  }
}

export class DateTimePickerField extends Component {
  render () {
    const {input: {onChange, value}, showTime} = this.props
    return (
      <FormFieldError {...this.props}>
        <DateTimePicker
          onChange={onChange}
          format='LLL'
          time={showTime}
          // requires value to be an array
          value={!value ? null : new Date(value)} />
      </FormFieldError>
    )
  }
}

export class MarkdownFieldEditor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      // editorState: EditorState.createWithContent(stateFromMarkdown(props.input.value))
      editorState: EditorState.createWithContent(convertFromRaw(mdToDraftjs(props.input.value)))
    }
  }

  onEditorStateChange (editorState) {
    const {input: {onChange}} = this.props
    this.setState({editorState})
    onChange(draftjsToMd(convertToRaw(editorState.getCurrentContent())))
  }

  render () {
    return (
      <Editor
        name='description'
        editorClassName='markdown-editor'
        editorState= {this.state.editorState}
        onEditorStateChange={this.onEditorStateChange.bind(this)}
        toolbar={{
          options: ['inline', 'blockType', 'list', 'link', 'remove', 'history']
        }}
      />
    )
  }
}
